import React, { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/config";

const DeliveryChargeEditor = ({ order, onUpdate, onCancel }) => {
  const [deliveryCharge, setDeliveryCharge] = useState(order.deliveryCharge || 0);
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    try {
      const orderRef = doc(db, "custom_orders", order.id);
      await updateDoc(orderRef, {
        deliveryCharge: Number(deliveryCharge),
        total: (order.qty * 20) + Number(deliveryCharge)
      });
      
      const updatedOrder = {
        ...order,
        deliveryCharge: Number(deliveryCharge),
        total: (order.qty * 20) + Number(deliveryCharge)
      };
      
      onUpdate(updatedOrder);
    } catch (error) {
      console.error("Error updating delivery charge:", error);
      alert("Failed to update delivery charge");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h3 className="text-lg font-semibold mb-4">Edit Delivery Charge</h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Delivery Charge (₹)
          </label>
          <input
            type="number"
            value={deliveryCharge}
            onChange={(e) => setDeliveryCharge(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
            min="0"
          />
        </div>
        
        <div className="bg-gray-50 p-3 rounded-lg">
          <p className="text-sm text-gray-600">
            <strong>Order Details:</strong>
          </p>
          <p className="text-sm">Quantity: {order.qty} rotis</p>
          <p className="text-sm">Base Price: ₹{order.qty * 20}</p>
          <p className="text-sm">Delivery Charge: ₹{deliveryCharge}</p>
          <p className="text-sm font-semibold">
            Total: ₹{(order.qty * 20) + Number(deliveryCharge)}
          </p>
        </div>
      </div>
      
      <div className="flex justify-end space-x-2 mt-6">
        <button
          onClick={onCancel}
          className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
          disabled={loading}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
};

export default DeliveryChargeEditor; 